module.exports = __webpack_public_path__ + "img/vacation-1.f6b0a1e3.jpg";